import { render, staticRenderFns } from "./PublicTradeContractTab.vue?vue&type=template&id=d5ab54d2&scoped=true&"
import script from "./PublicTradeContractTab.vue?vue&type=script&lang=js&"
export * from "./PublicTradeContractTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ab54d2",
  null
  
)

export default component.exports